// src/com/AppHead.js
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import LabisFunLogo from '../com/images/Lab-is-Fun-Logo.svg';
import LabisFunText from '../com/images/labisfun_text.svg';


const HeadBox = styled('div')({
    position: 'fixed', top: 0, left: 0, width: '100%',
    borderBottom: '2px solid #045B62',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    zIndex: 1000,
    padding: '5px 10px',
    boxSizing: 'border-box',
});

const LogoImg = styled('img')({
    height: 40, marginRight: 20,
});

const TextImg = styled('img')({
    height: 32, marginTop: 8,
});

// TODO: Menu to scroll to sections

export default function AppHead({
    onSelectMenu,
}) {

    // const onClickMenu = (menu) => {};
    
    return (
        <HeadBox>
            <LogoImg src={LabisFunLogo} alt="Lab is Fun Logo" />
            <TextImg src={LabisFunText} alt="Lab is Fun, Inc." />
        </HeadBox>
    );
}